import $ from 'jquery';

const defaults = {
  selector: '#edit-keywords',
};

function SearchCursor(element, options) {
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.listen();
}

SearchCursor.prototype = {
  listen() {
    this.$element.find(this.settings.selector)
      .on('focus', () => { this.$element.addClass('search-focus'); })
      .on('blur', () => { this.$element.removeClass('search-focus'); });
  },
};

export default SearchCursor;



// WEBPACK FOOTER //
// ./SearchCursor.js